export default __webpack_public_path__ + "static/media/facebook.ff353f45.svg";